import React, { useEffect, useState } from 'react';
import { ContentSection, Heading, Layout, Notification } from '@vwfs-bronson/bronson-react';
import { useTranslation } from 'react-i18next';
import { Greeting } from '../../components/greeting';
import { Contracts } from '../../components/contracts';
import { MarketingCard } from 'components/marketing-card/MarketingCard';
import { ContactDetailsCheckPendingNotification } from 'components/my-profile/address-section/contact-details-change-pending-notification';
import { useContactInformationChangeStatus } from 'components/my-profile/useContactInformationChangeStatus';
import { RequestStatus } from 'cpfr-common';
import { useLocation } from 'react-router-dom';

export const DashboardPage: React.FC = () => {
    const [hasMarketingCard, setHasMarketingCard] = useState(false);
    const { t } = useTranslation('dashboard');
    const title = t('headline');
    const { data: contactInformationChange } = useContactInformationChangeStatus();
    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);

    const showSuccessNotification = queryParams.get('success');

    useEffect(() => {
        document.title = 'Tableau de bord';
    }, [title]);

    return (
        <>
            <ContentSection pageWrapSize="medium">
                <Heading level={1}>{title}</Heading>
                <Greeting />
                <Layout>
                    {showSuccessNotification && (
                        <Notification
                            title={t('success-notification.title')}
                            className="u-ml"
                            visible
                            testId="contract-success-notification"
                            showCloseButton={false}
                            status={'success'}
                        >
                            <span
                                dangerouslySetInnerHTML={{
                                    __html: t('success-notification.text'),
                                }}
                            />
                        </Notification>
                    )}
                    {contactInformationChange?.requestCustomerStatus === RequestStatus.IN_PROGRESS && (
                        <Layout.Item default={hasMarketingCard ? '2/3' : '1/1'} m={'1/1'}>
                            <ContactDetailsCheckPendingNotification />
                        </Layout.Item>
                    )}

                    <Layout.Item default={hasMarketingCard ? '2/3' : '1/1'} m={'1/1'}>
                        <Contracts />
                    </Layout.Item>
                    <Layout.Item default={'1/3'} m={'1/1'}>
                        <MarketingCard setShouldRender={setHasMarketingCard} shouldRender={hasMarketingCard} />
                    </Layout.Item>
                </Layout>
            </ContentSection>
        </>
    );
};
